import {Link} from "react-router-dom";
import stringHelper from "../../helpers/string-helper";
import {useTranslation} from "react-i18next";

const SingleGameItem = ({game}) => {

    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    return (
        <div className="tournament__game">
            <Link
                to={stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${game.slug}`)}

                className="kush__cover">
                <span className="kush__img">
                  <img src={game.image} loading="lazy" alt=""/>
                </span>
                <div className="kush__title kush__title--yellow">
                    <h3>{game?.name}</h3>
                </div>
            </Link>
        </div>

    )
}
export default SingleGameItem
